import React, { FC } from 'react'
import Modal from '../../common/Modal'
import { useTranslation } from 'react-i18next'
import { CompanyExternalApiKey } from '../../../../states/types/setting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CopyableCode from '../../common/CopyableCode'

interface DetailExternalApiKeyModalState {
  isOpen: boolean,
  setIsOpen: (isOpen: boolean) => void,
}

interface Props {
  detailExternalApiKeyModalState: DetailExternalApiKeyModalState
  companyExternalApiKey: CompanyExternalApiKey
  closeCallback?: VoidFunction
  closeable?: boolean
}

const DetailExternalApiKeyModal: FC<Props> = (props) => {
  const {
    detailExternalApiKeyModalState,
    companyExternalApiKey,
    closeCallback,
    closeable,
  } = props

  const { t } = useTranslation()

  return (
    <Modal
      title="APIキーの確認"
      show={detailExternalApiKeyModalState.isOpen}
      wrapperClass="setting_external_api_key"
      closeCallback={closeCallback}
      closeable={closeable}
    >
      {/* モーダルボディ */}
      <>
        <div className="api-key-instruction">
          こちらのAPIキーをコピーして使用してください。
          {/* <br />
          <a href="https://qasee.zendesk.com/hc/ja/articles/4412116963353/" target="_blank">ドキュメントはこちらでご確認いただけます。</a>
          <br /> */}
        </div>

        <div className="api-key-container">
          <label htmlFor={t('model.externalApiKey.apiKey')}>{t('model.externalApiKey.apiKey')}</label>

          <CopyableCode
            code={companyExternalApiKey.api_key}
          />

        </div>

        <div className="api-guidelines-section">
          <h3 className="section-title">
            <FontAwesomeIcon icon={['fas', 'info-circle']} className="section-icon" />
            API利用に際しての注意点
          </h3>
          <div className="api-guidelines">
            <div className="guideline-item">
              <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} className="guideline-icon" />
              <div className="guideline-text">
                APIリクエストの回数は、1分間に60回が上限となります。
                <br />
                上限は、APIキーごとではなく、会社全体での制限となりますのであらかじめご留意ください。
              </div>
            </div>
          </div>
        </div>

      </>

      {/* モーダルフッター */}
      <>
        <button type="button" className="button cancel" onClick={closeCallback} disabled={!closeable}>
          閉じる
        </button>
      </>
    </Modal>
  )
}

DetailExternalApiKeyModal.defaultProps = {
  closeable: true,
}

export default DetailExternalApiKeyModal
